import React from 'react';
import useMsalHook from '../../auth/useMsalHook';
import ServiceManagementApp from './ServiceManagement/ServiceManagementApp';
import SMLoadingSpinner from './ServiceManagement/components/SMLoadingSpinner';

const ServiceManagementWrapper: React.FC = () => {
  const { user, userToken, logout } = useMsalHook();

  if (!user) {
    return <SMLoadingSpinner />;
  }

  return <ServiceManagementApp user={user} userToken={userToken} onLogout={logout} />;
};

export default ServiceManagementWrapper;
